import { useCallback } from 'react';
import {
  useQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  OperationVariables,
  QueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/PartnerAgencyPermission.graphql';
import { Query } from '../../__generated__/globalTypes';

export const usePartnerAgencyPermissionQuery = (options?: QueryHookOptions<Query>) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const usePartnerAgencyPermissionLazyQuery = (
  options?: LazyQueryHookOptions<Query>
): QueryResult<Query> & { getPartnerAgencyPermissionQuery: LazyQueryExecFunction<Query, OperationVariables> } => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  // TODO: should be getPartnerAgencyPermission
  const [getPartnerAgencyPermissionQuery, result] = useLazyQuery<Query>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getPartnerAgencyPermissionQuery, ...result };
};

export const usePartnerAgencyPermissionPromiseQuery = () => {
  const client = useApolloClient();

  const getPartnerAgencyPermission = useCallback(
    (options?: Omit<QueryOptions<Record<string, unknown>, Query>, 'query'>) =>
      client.query<Query>({ ...options, query: QUERY }),
    [client]
  );

  return { getPartnerAgencyPermission };
};
